import PanelBoxError from 'errors/components/PanelBoxError'
import { IError } from 'errors/types/IError'
import { t } from 'localization'
import CreateAccountForm from 'login/components/CreateAccountForm'
import LoginForm from 'login/components/LoginForm'
import { SingletonRouter, useRouter, withRouter } from 'next/router'
import qs from 'qs'
import { FC, useState } from 'react'
import { Panel } from 'shared/components/Panel'
import { setUserLoggedInFromFavoritesFlow } from 'store/favoritesSlice'
import { UserAuthQA } from 'shared/dataAttributes'
import { useAppDispatch } from 'store/hooks'

const TP = 'login.components.LoginPanel'

enum View {
  Login,
  CreateAccount,
}

interface ILoginPanelProps {
  favoritesFlow?: boolean
  handleClose?: () => void
  router: SingletonRouter
  redirectUrl?: {
    [key: string]: undefined | string | string[] | qs.ParsedQs | qs.ParsedQs[]
  }
  withCloseButton?: boolean
  location: 'pdp_favorite' | 'global_favorite_panel'
}

export const LoginPanel: FC<ILoginPanelProps> = ({
  router,
  redirectUrl = {},
  withCloseButton,
  handleClose,
  favoritesFlow,
  location,
}) => {
  const [currentView, setCurrentView] = useState(View.Login)
  const [pageErrors, setPageErrors] = useState<IError[]>([])

  const { locale } = useRouter()
  const dispatch = useAppDispatch()

  const handleCreateAccountClick = () => {
    setPageErrors([])
    setCurrentView(View.CreateAccount)
  }
  const handleLoginClick = () => {
    setPageErrors([])
    setCurrentView(View.Login)
  }

  const handleComplete = () => {
    if (favoritesFlow) {
      return dispatch(setUserLoggedInFromFavoritesFlow(true))
    }
    setPageErrors([])

    if (redirectUrl && redirectUrl.redirectTo) {
      const formattedQueryString = qs.stringify(redirectUrl, {
        addQueryPrefix: true,
        filter: (prefix, value) => {
          if (prefix === 'redirectTo') {
            return
          }
          return value
        },
      })
      router.push(
        `${redirectUrl.redirectTo}${formattedQueryString}`,
        `${redirectUrl.redirectTo}${formattedQueryString}`,
        { locale },
      )
    } else {
      router.push(`/`, '/', { locale })
    }
  }

  const handleError = (errors: IError[]) => {
    setPageErrors(errors)
    window.scrollTo(0, 0)
  }

  const title =
    currentView === View.Login
      ? t(`${TP}.logIn`, 'Log in')
      : t(`${TP}.createAnAccount`, 'Create A Flight Club Account')
  const qaAttr = currentView === View.Login ? UserAuthQA.Login : UserAuthQA.CreateAccount

  return (
    <>
      {pageErrors?.map((error, i) => (
        <PanelBoxError key={i} qaAttr={`${qaAttr}ErrorTopPage`} message={error} />
      ))}
      <Panel
        qaAttr={qaAttr}
        title={title}
        withCloseButton={withCloseButton}
        handleClose={handleClose}
        className={qaAttr}
      >
        {currentView === View.Login ? (
          <LoginForm
            onCreateAccountClick={handleCreateAccountClick}
            onLogin={handleComplete}
            onLoginError={handleError}
            location={location || 'account_page'}
          />
        ) : (
          <CreateAccountForm
            onLoginClick={handleLoginClick}
            onCreateAccount={handleComplete}
            onCreateAccountError={handleError}
            location={location || 'account_page'}
            loginInsteadStyle="button"
          />
        )}
      </Panel>
    </>
  )
}

export default withRouter(LoginPanel)
